import { Match } from "../directus/collections";
import { EnigmaMetrics } from "../libs/gameAnalysis/enigma";
import { TimelineEntry } from "../libs/gameAnalysis/timeline";
import {
  createIDBHandler,
  IDBHandler,
  IndexedDbObjectStoreInitParams,
  initIDB,
} from "../libs/indexedDb";
import { CityEscapeData } from "../types/cityEscape";
export interface GaripalliIDBDatabaseSchema {
  matches: Match;
  // match_events: MatchEvent;
  sync_metadata: SyncMetadata;
  city_escapes: CityEscapeData;
  enigma_metrics: EnigmaMetrics;
  timelines: TimelineEntry;
}
export type GaripalliIDB = IDBHandler<GaripalliIDBDatabaseSchema>;

export interface IndexedDbConfigs<S> {
  name: string;
  version?: number;
  objectsStores: IndexedDbObjectStoreInitParams<S>[];
}

export type SyncMetadata = {
  id: string;
  matches: {
    lastSyncedAt: number;
    skips?: number;
    lastItemId?: string;
    challengeStatsCalculated: boolean;
  };
  match_events: {
    lastSyncedAt: number;
    skips?: number;
    lastItemId?: string;
  };
};

const GARIPALLI_IDB_CONFIGS: IndexedDbConfigs<GaripalliIDBDatabaseSchema> = {
  name: import.meta.env.VITE_DB_NAME,
  version: import.meta.env.VITE_DB_VERSION,
  objectsStores: [
    {
      name: "matches",
      keyPath: "id",
      indexes: [{ name: "city_escape", keyPath: "city_escape" }],
      autoincrement: false,
    },
    {
      name: "timelines",
      keyPath: "id",
      autoincrement: false,
      indexes: [
        { name: "matchId", keyPath: "matchId" },
        {
          name: "matchByDate",
          keyPath: ["matchId", "date"],
        },
        { name: "targetId", keyPath: "targetId" },
        { name: "byCityEscape", keyPath: "cityEscapeId" },
        {
          name: "eventsOfTypeByCityEscape",
          keyPath: ["cityEscapeId", "type"],
        },
        {
          name: "eventOfTypeByChallenge",
          keyPath: ["challenge.id", "type"],
        },
        {
          name: "dropsByCityEscape",
          keyPath: ["cityEscapeId", "isDrop"],
        },
        {
          name: "dropsByChallenge",
          keyPath: ["challenge.id", "isDrop"],
        },
        {
          name: "globalDrops",
          keyPath: "isDrop",
        },
        {
          name: "bugsByCityEscape",
          keyPath: ["cityEscapeId", "bugs.hasBug"],
        },
        {
          name: "bugsByChallenge",
          keyPath: ["challenge.id", "bugs.hasBug"],
        },
        {
          name: "globalBugs",
          keyPath: "bugs.hasBug",
        },
      ],
    },
    {
      name: "sync_metadata",
      keyPath: "id",
      autoincrement: false,
    },
    {
      name: "city_escapes",
      keyPath: "id",
      autoincrement: false,
    },
  ],
};

Object.freeze(GARIPALLI_IDB_CONFIGS);

export { GARIPALLI_IDB_CONFIGS };

export async function getGaripalliIDB(): Promise<GaripalliIDB> {
  const db = await initIDB(
    GARIPALLI_IDB_CONFIGS.name,
    GARIPALLI_IDB_CONFIGS.version,
    GARIPALLI_IDB_CONFIGS.objectsStores
  );
  if (!db) throw new Error("Failed to initialize Garipalli IndexedDB");
  return createIDBHandler<GaripalliIDBDatabaseSchema>(db);
}
